import React, { useCallback, useState } from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Grid,
    CircularProgress,
    Chip
} from '@material-ui/core';
import { DeleteIcon, EditIcon } from '../../../icons';
import ActionIconButton from '../../../components/atom/ActionIconButton';

import TablePager from '../../../components/atom/TablePager';
import { MODAL_TYPE, useModals } from '../../../hooks/useModal';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import AdminHeader from '../../../components/atom/AdminHeader';

function CancelReasonsListPage() {
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const { showModal } = useModals();
    const { notifyError, notifySuccess } = useNotify();

    const [data, loading, error, setData, reloadCancelReasons] = useSwaggerClient(
        'cancelreasons',
        'getAllCancelReasons',
        {
            page,
            pageSize,
            search
        }
    );

    const deleteCancelReason = useCallback(
        cancelReasonId => {
            doSwaggerCall('cancelreasons', 'deleteCancelReason', { cancelReasonId })
                .then(() => {
                    notifySuccess('Cancel reason deleted!');
                    reloadCancelReasons();
                })
                .catch(() => {
                    notifyError('Cannot delete cancel reason!');
                });
        },
        [setData, data, notifyError, notifySuccess]
    );

    if (error) {
        return (
            <Grid container justifyContent="center">
                <h1>{error}</h1>
            </Grid>
        );
    }

    return (
        <Grid container className="bg-white client-table page" alignItems="center" spacing={2}>
            <AdminHeader
                title="Cancel Reasons"
                search={search}
                onSearch={newSearch => {
                    setPage(0);
                    setSearch(newSearch);
                }}
                createLabel="New cancel reason"
                onCreate={() => {
                    showModal(MODAL_TYPE.CREATE_CANCEL_REASON);
                }}
            />
            <Grid item container xs={12} justifyContent="center">
                {loading && data?.cancelReasons.length === 0 ? (
                    <CircularProgress />
                ) : (
                    <Table style={{ backgroundColor: 'white' }} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Requires Note</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data &&
                                data.cancelReasons &&
                                data.cancelReasons.map(cancelReason => (
                                    <TableRow key={cancelReason.id}>
                                        <TableCell>{cancelReason.name}</TableCell>
                                        <TableCell>{cancelReason.description}</TableCell>
                                        <TableCell>
                                            {cancelReason.requires_note ? (
                                                <Chip label="Required" size="small" color="primary" />
                                            ) : (
                                                <Chip label="Optional" size="small" color="default" />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: 100 }}>
                                            <ActionIconButton
                                                title="Edit"
                                                icon={EditIcon}
                                                to={`/admin/cancelreasons/update/${cancelReason.id}`}
                                            />
                                            <ActionIconButton
                                                title="Delete"
                                                icon={DeleteIcon}
                                                onClick={() => {
                                                    showModal(MODAL_TYPE.CONFIRMATION, {
                                                        title: `Are you sure you want to remove ${cancelReason?.name}?`,
                                                        content: 'This action is irreversible.',
                                                        confirm: () => deleteCancelReason(cancelReason.id)
                                                    });
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                )}
                <Grid container justifyContent="flex-end">
                    <TablePager
                        total={data?.total}
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default CancelReasonsListPage;